import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  grow: {
    flexGrow: 1
  }
}));
